import { forwardRef } from 'react';
import { type SupportedLocale } from '@zep-us/i18n';
import { GlobeIcon } from '@/icons';
import { type LanguageSelectorProps } from '@/shared/components/LanguageSelector/LanguageSelector';
import { LanguageSelectorTooltip } from '@/shared/components/LanguageSelector/LanguageSelectorTooltip';
import { Button } from '@/ui_v3';
type LanguageSelectorTriggerProps = LanguageSelectorProps & {
  currentLocale: SupportedLocale;
  onClick: () => void;
  className?: string;
  hideTooltip: boolean;
};
export const LanguageSelectorTrigger = forwardRef<HTMLButtonElement, LanguageSelectorTriggerProps>(({
  onClick,
  currentLocale,
  className,
  rounded,
  size,
  iconSize,
  intent,
  variant,
  hideTooltip
}, ref) => {
  return <LanguageSelectorTooltip align={'end'} side={'bottom'} isHide={hideTooltip}>
        <Button ref={ref} type="button" variant={variant ?? 'contained'} intent={intent ?? 'neutral'} size={size} onClick={onClick} rounded={rounded || 'full'} className={className} leftSlot={<GlobeIcon size={iconSize ?? 'sm'} />}>
          {currentLocale}
        </Button>
      </LanguageSelectorTooltip>;
});
LanguageSelectorTrigger.displayName = 'LanguageSelectorTrigger';